// extracted by mini-css-extract-plugin
export default {"parentContainer":"OurServices_parentContainer__Ixvqp","bg":"OurServices_bg__kNUVO","img":"OurServices_img__e0MtG","serviceDescription":"OurServices_serviceDescription__24Ccx"};